<template>
    <div class=" my">
        <nav-bar title="活动图片"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" class="my-nav"/>
        <div style="margin-top: 2.9rem"></div>

        <cell-group title="活动图片">
            <uploader :disabled="disabled"
            :file-list="list" style="margin: 1rem" multiple
                      result-type="file"
                      :after-read="afterRead" @delete="deleteF"/>
            <div v-show="!disabled" style="margin: 16px;">
                <ant-button round block type="danger" :loading="loading" @click="submit">
                    提交
                </ant-button>
            </div>
        </cell-group>
    </div>
</template>

<script>
    import {Uploader, NavBar, CellGroup, Button, Toast} from 'vant'
    import service from "../../api/service";
    import lrz from "lrz";

    export default {
        name: "updataImg",
        components: {
            Uploader, NavBar, CellGroup, AntButton: Button
        },
        data() {
            return {
                loading: false,
                id: '-',
                list: [],
                upSum: 0,
                disabled:false
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.disabled = !!this.$route.query.disabled
            console.log(this.disabled);
            this.init()
        },
        methods: {
            init() {
                service.get('/api/activity-creation-approval/img', {id: this.id}).then(res => {
                    if (res.status === 200) {
                        let arr = []
                        res.data.forEach(v => {
                            arr.push({
                                url: v
                            })
                        })
                        this.list = arr
                    }
                })
            },
            submit() {
                let arr = []
                this.list.forEach(v => {
                    arr.push(v.url)
                })
                service.post('/api/activity-creation-approval/updateImg', {
                    id: this.id,
                    activityImgUrls: arr
                }).then(res => {
                    if (res.status === 200) {
                        Toast.success(res.message)
                        this.onClickLeft()
                    } else {
                        Toast.fail(res.message)
                    }
                })
            },

            afterRead(f) {
                this.loading = true
                console.log(f, '======')
                if (Array.isArray(f)) {
                    this.upSum = f.length
                    f.forEach(v => {
                        this.upFile(v)
                    })
                } else {
                    this.upFile(f)
                }

            },
            upFile(f) {
                // 此时可以自行将文件上传至服务器
                let formData = new FormData();
                // 获取文件对象
                let file = f.file;
                let fileName = file.name
                // 压缩前文件大小
                let imgUrl = URL.createObjectURL(file, {quality: 0});
                lrz(imgUrl).then(rst => {
                    // 压缩后文件大小
                    let fff = this.base64ToFile(rst.base64, fileName)
                    formData.append('file', fff)
                    formData.append('userName', 'userName')
                    service.post('/file-up/resources/import', formData).then(res => {
                        if (res.status === 200) {
                            this.upSum--
                            if (this.upSum <= 0) {
                                this.loading = false
                            }
                            this.list.push({
                                url: service.baseURLB + res.data.fileUrl
                            })
                        }
                    })
                });

            },
            base64ToFile(dataurl, filename) {
                let arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type: mime});
            },
            onClickLeft() {
                // this.$router.push({path: '/launchEvent'})
                this.$router.go(-1)
            },
            deleteF(f, i) {
                if(this.disabled) return;
                this.list.splice(i.index, 1)
            }
        }
    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }

</style>